import type { TagProps } from '@standardsdigital/ui-components/Tag';
import type { IconName } from '@standardsdigital/ui-components/Icon';
import type { SearchResultStatus } from '@/types/search';
import { SearchResultContentType } from '@/types/search';

export const mapContentTypeToIcon: Record<
  SearchResultContentType,
  keyof typeof IconName
> = {
  standard: 'FileText',
  publication: 'File',
  eform: 'File',
  collection: 'Layers',
  physical: 'File',
  other: 'List',
  training: 'File',
  service: 'File',
  committeePage: 'File',
  articlePage: 'Newspaper',
  newsArticlePage: 'File',
  coursePage: 'GraduationCap',
  contentPage: 'File',
  newsListPage: 'File',
  committeeListPage: 'File',
  startPage: 'File',
} as const;

export const mapStatusToIcon: Record<SearchResultStatus, keyof typeof IconName> = {
  none: 'PenLine',
  published: 'Check',
  withdrawn: 'Circle',
  draft: 'PenLine',
  inDevelopment: 'PenLine',
  replaced: 'Circle',
  revised: 'PenLine',
  historicalDraft: 'Circle',
} as const;

export const mapStatusToVariant: Record<SearchResultStatus, TagProps['variant']> = {
  none: 'neutral',
  published: 'success',
  withdrawn: 'warning',
  draft: 'neutral',
  inDevelopment: 'neutral',
  replaced: 'warning',
  revised: 'neutral',
  historicalDraft: 'warning',
} as const;

export const contentTypesWithStatus = new Set<SearchResultContentType>([
  SearchResultContentType.Standard,
  SearchResultContentType.Collection,
  SearchResultContentType.Eform,
  SearchResultContentType.Publication,
  SearchResultContentType.Other,
  SearchResultContentType.Physical,
  SearchResultContentType.Training,
]);

export const idPrefix = 'search';

export const maxAllowedTotalPages = 100;

export const maxVisibleFilterItems = 5;
